import { render, staticRenderFns } from "./OrganizationViewOrganizationPermissionsCard.vue?vue&type=template&id=14d6f70e"
import script from "./OrganizationViewOrganizationPermissionsCard.vue?vue&type=script&lang=js"
export * from "./OrganizationViewOrganizationPermissionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports